/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiContainerAction, ApiContainerType } from '@Model';
import type { HttpActions, ListInfo, ListRequest, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ContainerActionContainerTypeController.
 */
export class ContainerActionContainerTypeRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /orders/{rootObjectId}/container_actions/{subObjectId}/container_type:prefill
     */
    public createPrefilled(subObjectId: string, rootObjectId: string): Promise<Result<ApiContainerType>> {
        return this.http.post<Result<ApiContainerType>, undefined>(`/orders/${rootObjectId}/container_actions/${subObjectId}/container_type:prefill`, undefined);
    }

    /**
     * Calls PATCH /orders/{rootObjectId}/container_actions/{subObjectId}/container_type
     */
    public addLinkedObject(id: string, subObjectId: string, rootObjectId: string): Promise<Result<ApiContainerAction>> {
        const query = new URLSearchParams();
        query.set('id', `${id}`);

        return this.http.patch<Result<ApiContainerAction>, undefined>(`/orders/${rootObjectId}/container_actions/${subObjectId}/container_type`, undefined, query);
    }

    /**
     * Calls POST /orders/{rootObjectId}/container_actions/{subObjectId}/container_type/linkable:query
     */
    public getLinkableObjects(listRequest: ListRequest, showAll: boolean, subObjectId: string, rootObjectId: string): Promise<Result<ListInfo<ApiContainerType>>> {
        const query = new URLSearchParams();
        query.set('showAll', `${showAll}`);

        return this.http.post<Result<ListInfo<ApiContainerType>>, ListRequest>(`/orders/${rootObjectId}/container_actions/${subObjectId}/container_type/linkable:query`, listRequest, query);
    }

    /**
     * Calls DELETE /orders/{rootObjectId}/container_actions/{subObjectId}/container_type
     */
    public deleteLinkedObject(id: string, subObjectId: string, rootObjectId: string): Promise<Result<ApiContainerAction>> {
        const query = new URLSearchParams();
        query.set('id', `${id}`);

        return this.http.delete<Result<ApiContainerAction>>(`/orders/${rootObjectId}/container_actions/${subObjectId}/container_type`, query);
    }
}
